<template>
    <div class="details-elements-grid">
        <template v-if="event.catering">
            <EventEntryDetailsElement :heading="$t('iFrame.catering')" icon="utensils">
                {{event.catering}}
            </EventEntryDetailsElement>
        </template>
        <template v-if="event.accommodation">
            <EventEntryDetailsElement :heading="$t('iFrame.accommodation')" icon="bed">
                {{event.accommodation}}
            </EventEntryDetailsElement>
        </template>
        <template v-if="event.arrivalDirections">
            <EventEntryDetailsElement :heading="$t('iFrame.arrivalDirections')" icon="route">
                {{event.arrivalDirections}}
            </EventEntryDetailsElement>
        </template>
        <template v-if="event.travelDocuments">
            <EventEntryDetailsElement :heading="$t('iFrame.travelDocuments')" icon="passport">
                {{event.travelDocuments}}
            </EventEntryDetailsElement>
        </template>
        <template v-if="event.services">
            <EventEntryDetailsElement :heading="$t('iFrame.otherServices')" icon="concierge-bell">
                {{event.services}}
            </EventEntryDetailsElement>
        </template>
    </div>
</template>

<script>
import EventEntryDetailsElement
    from "@/components/pages/eventIFrame/EventEntry/EventEntryDetails/EventEntryDetailsElement";

export default {
    name: "EventEntryServices",
    components: {EventEntryDetailsElement},
    props: {
        event: {
            type: Object,
            required: true
        }
    },
}
</script>

<style lang="scss" scoped>

</style>
